import loadable from '@loadable/component'
import { globalData } from '../common/config'
import {URLSearchParams} from '../utils/url'
import {currentProductCode} from '../productConfig'
const urlParams =  (URLSearchParams(window.location.href)) as any
const productCode = urlParams['productCode'] || currentProductCode;
export const routesConfig = [
  {
    path: '/',
    exact: true,
    name: 'Detail',
    text: '保单详情',
    query:{productCode:''},
    component: loadable(() => import(/* webpackChunkName: "Detail" */ '../pages/Detail/Detail'))
  },
  {
    path: '/policy',
    exact: true,
    name: 'Policy',
    text: '填写确认保单',
    component: loadable(() => import(/* webpackChunkName: "Policy" */ '../pages/Policy/Policy'))
  },
  {
    path: '/order',
    exact: true,
    name: 'Order',
    text: '保单详情',
    component: loadable(() => import(/* webpackChunkName: "Order" */ '../pages/Order/Order'))
  },
  {
    path: '/orderAli',
    exact: true,
    name: 'Order',
    text: '保单详情',
    component: loadable(() => import(/* webpackChunkName: "Order" */ '../pages/Order/OrderAli'))
  }
]
